import { Injectable } from '@angular/core';
import { type Notification, NotificationService } from '@fino-ui/notification';
import type { IndividualConfig } from 'ngx-toastr';
import { ErrorNotificationComponent } from '../../components/error-notification/error-notification.component';

/**
 * Replaces the fino NotificationService so every error notification renders
 * with our own toast component. Provided for NotificationService in
 * app.config.ts, so existing call sites keep injecting the fino service.
 */
@Injectable()
export class AppNotificationService extends NotificationService {
  override error(
    message: string,
    title?: string,
    options?: Partial<IndividualConfig>,
  ): Notification {
    return super.error(message, title, {
      toastComponent: ErrorNotificationComponent,
      // Errors are meant to be read and copied, so the toast must survive
      // being touched: extendedTimeOut defaults to 1s, which would close it a
      // second after the mouse leaves, and tapToDismiss would close it as soon
      // as the message text is clicked. The toast brings its own close button.
      extendedTimeOut: this.options.timeOut,
      tapToDismiss: false,
      ...options,
    });
  }
}
